import React from 'react';
import type { ConfiguratorModule as ConfiguratorModuleData } from 'libs/sanity/types/generated';
import ConfiguratorBlock from 'libs/sanity/content/Blocks/ConfiguratorBlock';

interface ConfiguratorModuleProps {
    data?: ConfiguratorModuleData;
}

const ConfiguratorModule: React.FC<ConfiguratorModuleProps> = () => <ConfiguratorBlock />;

export default ConfiguratorModule;
